export default "__VITE_ASSET__b8b1b0e7__"